import { ThunkDispatch } from "redux-thunk"
import { AppState } from "../app-state"
import { Action } from "redux"
import { action } from "typesafe-actions"
import { CompanyProfileActionTypes, InviteResponse } from "./company-profile.types"
import { companyProfileApi } from "../../api/talent/company-profile-service"


export const fetchGroupUsers = (companyId: string) => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CompanyProfileActionTypes.GET_GROUP_USERS));
        try {
            const response = await companyProfileApi.fetchGroupUsers(companyId);
            dispatch(
                action(CompanyProfileActionTypes.GET_GROUP_USERS_SUCCESS, response.data)
            );
        } catch (error) {
            dispatch(action(CompanyProfileActionTypes.GET_GROUP_USERS_ERROR, error));
        }
    }
}

export const fetchInvites = (companyId: string) => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CompanyProfileActionTypes.GET_INVITES));
        try {
            const response = await companyProfileApi.fetchOpenInvites(companyId);
            dispatch(
                action(CompanyProfileActionTypes.GET_INVITES_SUCCESS, response.data)
            );
        } catch (error) {
            dispatch(action(CompanyProfileActionTypes.GET_INVITES_ERROR, error));
        }
    }
}

export const checkEmailDomain = async (email: string): Promise<{ valid: boolean }> => {
    const response = await companyProfileApi.checkEmailDomain(email);
    return response.data;
};

export const sendInvite = async (email: string): Promise<InviteResponse> => {
    const response = await companyProfileApi.sendInvite(email);
    return response.data as InviteResponse;
};

export const invalidateInvite = (key: string, company_id: string) => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CompanyProfileActionTypes.INVALIDATE_INVITE));
        try {
            const response = await companyProfileApi.invalidateInvite(key);
            dispatch(fetchInvites(company_id));
            dispatch(
                action(CompanyProfileActionTypes.INVALIDATE_INVITE_SUCCESS, response.data)
            );
        } catch (error) {
            dispatch(action(CompanyProfileActionTypes.INVALIDATE_INVITE_ERROR, error));
        }
    }
};

export const removeTeamate = (id: string, company_id: string) => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CompanyProfileActionTypes.REMOVE_TEAMATE));
        try {
            const response = await companyProfileApi.removeTeamate(id, company_id);
            dispatch(fetchGroupUsers(company_id));
            dispatch(
                action(CompanyProfileActionTypes.REMOVE_TEAMATE_SUCCESS, response.data)
            );
        } catch (error) {
            dispatch(action(CompanyProfileActionTypes.REMOVE_TEAMATE_ERROR, error));
        }
    }
};